function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 9,
  r: 9,
  fill: "#789EFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.2724 11.7693L9.50317 9.00013L12.2724 6.23093C12.3391 6.16416 12.3766 6.07361 12.3766 5.97919C12.3766 5.88476 12.3391 5.79421 12.2724 5.72744C12.2056 5.66067 12.115 5.62316 12.0206 5.62316C11.9262 5.62316 11.8356 5.66067 11.7689 5.72744L8.99968 8.49664L6.23048 5.72744C6.16371 5.66067 6.07316 5.62317 5.97874 5.62316C5.88431 5.62316 5.79376 5.66067 5.72699 5.72744C5.69303 5.75892 5.66621 5.79731 5.64834 5.84002C5.63047 5.88274 5.62197 5.92879 5.6234 5.97507C5.62483 6.02135 5.63616 6.06679 5.65664 6.10832C5.67711 6.14985 5.70625 6.18651 5.74209 6.21583L8.51129 8.98502L5.72699 11.7693C5.66022 11.8361 5.62271 11.9266 5.62271 12.0211C5.62271 12.1155 5.66022 12.206 5.72699 12.2728C5.79376 12.3396 5.88431 12.3771 5.97873 12.3771C6.07316 12.3771 6.16371 12.3396 6.23048 12.2728L8.99968 9.50362L11.7689 12.2728C11.8356 12.3396 11.9262 12.3771 12.0206 12.3771C12.115 12.3771 12.2056 12.3396 12.2724 12.2728C12.3391 12.206 12.3766 12.1155 12.3766 12.0211C12.3766 11.9266 12.3391 11.8361 12.2724 11.7693Z",
  fill: "white",
  stroke: "white",
  strokeWidth: 1.5
});

function SvgCloseicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseicon);
export default __webpack_public_path__ + "static/media/close.icon.9448c925.svg";
export { ForwardRef as ReactComponent };